<template>
  <Overlay :show="show">
    <div class="wrapper" @click.stop>
      <div class="block">
        <span class="close" @click="close">关闭</span>
        <div class="count">您有{{ count }}次抽奖机会</div>
        <div class="background">
          <img v-show="backgrund_active === 0" :src="backgrund[0]" alt="" />
          <img v-show="backgrund_active === 1" :src="backgrund[1]" alt="" />
        </div>
        <div class="select">
          <template v-for="item in 8">
            <img
              :key="item"
              :class="{
                active: item === select_active,
                biling: finish && !runing,
              }"
              :src="require('@/assets/activityplace/lottery_active.png')"
            />
          </template>
        </div>
        <div class="goods">
          <div
            class="good"
            v-for="(item, index) in goods"
            :key="'good-' + item.id"
          >
            <div
              class="good-item"
              :class="{ active: index + 1 === select_active }"
            >
              <div
                class="img"
                v-if="item.img"
                :style="{ backgroundImage: 'url(' + item.img + ')' }"
              ></div>
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="btn" @click="runStart"></div>
        <div class="submit" @click="runStart">立即参与</div>
      </div>
    </div>
  </Overlay>
</template>

<script>
import { Overlay, Toast } from "vant";
import TWEEN from "@tweenjs/tween.js";
import {
  getOverlayCount,
  getOverlayList,
  getOverlayResult,
} from "@/api/lotteryPlace";
export default {
  components: { Overlay },
  data() {
    return {
      show: false,
      backgrund_active: 0,
      backgrund: [
        require("@/assets/activityplace/lottery_bg_0.png"),
        require("@/assets/activityplace/lottery_bg_1.png"),
      ],
      count: "-",
      goods: [],
      select_active: 0,
      interval: null,
      runing: false,
      finish: false,
    };
  },
  beforeDestroy() {},
  methods: {
    open() {
      this.show = true;
      this.count = "-";
      this.select_active = 0;
      this.runing = false;
      this.finish = false;
      this.getOverlayCount();
      this.getOverlayList();
    },
    close() {
      TWEEN.removeAll();
      this.show = false;
      this.interval && clearInterval(this.interval);
    },
    getOverlayCount() {
      getOverlayCount().then((res) => {
        this.count = res.data;
      });
    },
    getOverlayList() {
      getOverlayList().then((res) => {
        this.goods = res.data.map((item) => {
          const obj = { id: item.id, name: item.awardName, type: item.type };
          switch (item.type) {
            case "GOODS":
              obj.img = item.goods[0]?.goodsImg;
              break;
            case "CASH":
            case "RED_PACKET":
              obj.img = require("@/assets/activityplace/lottery_redpack.png");
              break;
          }
          return obj;
        });
      });
    },
    runStart() {
      if (this.count === 0) {
        return Toast.fail("没有抽奖机会了");
      }
      if (this.runing) {
        return;
      }
      this.runing = true;

      let currentSpeed = null;
      let lotteryResult = false;
      let lotteryResultObj = null;
      let lotteryResultNum = 1;

      this.step();
      new TWEEN.Tween({ interval: 500 })
        .to({ interval: 100 }, 2 * 1000)
        .easing(TWEEN.Easing.Quadratic.In)
        .onUpdate((object) => {
          setTimeout(() => {
            this.step();
            animate();
          }, object.interval);
          currentSpeed = object.interval;
        })
        .onComplete(() => {
          setTimeout(() => {
            speedUniformAnimate();
          }, currentSpeed);
          getData();
        })
        .start();

      const getData = () => {
        getOverlayResult().then((res) => {
          lotteryResultObj = res.data;
          lotteryResultNum =
            this.goods.findIndex((item) => item.id === res.data.awardId) + 1;
          lotteryResult = true;
          this.getOverlayCount();
        });
      };

      const speedUniformAnimate = () => {
        if (this.show === false) {
          return;
        }
        setTimeout(() => {
          if (lotteryResult) {
            speedDownTweenAnimate();
            this.step();
            animate();
          } else {
            this.step();
            speedUniformAnimate();
          }
        }, currentSpeed);
      };

      const speedDownTweenAnimate = () => {
        new TWEEN.Tween({ interval: currentSpeed })
          .to({ interval: 350 }, 2 * 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate((object) => {
            setTimeout(() => {
              this.step();
              animate();
            }, object.interval);
            currentSpeed = object.interval;
          })
          .onComplete(() => {
            setTimeout(() => {
              speedEndUniformAnimate();
            }, currentSpeed);
          })
          .start();
      };

      const speedEndUniformAnimate = () => {
        if (this.show === false) {
          return;
        }
        setTimeout(() => {
          if (lotteryResultNum === this.select_active) {
            this.runing = false;
            this.finish = true;
            this.winningResult(lotteryResultNum, lotteryResultObj);
          } else {
            this.step();
            speedEndUniformAnimate();
          }
        }, currentSpeed);
      };

      function animate() {
        TWEEN.update();
      }
      animate();
    },
    winningResult(lotteryResultNum, lotteryResultObj) {
      const selected = this.goods[lotteryResultNum - 1];
      switch (selected.type) {
        case "THANKS":
          Toast("很遗憾，没有中奖");
          break;
        case "CASH":
          Toast('恭喜您，抽中"' + selected.name + '"，前往余额查看');
        case "RED_PACKET":
          Toast('恭喜您，抽中"' + selected.name + '"，前往红包中心查看');
          break;
        case "GOODS":
          Toast('恭喜您，抽中"' + selected.name + '"');
          setTimeout(() => {
            this.winningGoods(lotteryResultObj);
          }, 2000);
          break;
      }
    },
    // 抽中商品
    winningGoods(lotteryResultObj) {
      this.$router.push({
        name: "Settle",
        params: { fid: 0 },
        query: { awardId: lotteryResultObj.awardRecordId },
      });
    },
    step() {
      let num = this.select_active;
      this.backgrund_active = this.backgrund_active ? 0 : 1;
      this.select_active = (num % 8) + 1;
    },
  },
};
</script>

<style lang="less" scoped>
.van-overlay {
  z-index: 99;
  text-align: center;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    position: relative;
    width: 726px;
    height: 898px;
    margin: 0 auto;
    .close {
      position: absolute;
      display: inline-block;
      padding: 10px 20px;
      font-size: 26px;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      right: 20px;
      top: -60px;
    }
    .count {
      position: absolute;
      top: 192px;
      left: 0;
      width: 100%;
      font-size: 28px;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
    }
    .background {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .btn {
      position: absolute;
      top: 416px;
      left: 278px;
      width: 166px;
      height: 166px;
      background-color: transparent;
    }
    .submit {
      position: absolute;
      bottom: -130px;
      left: 50%;
      margin-left: -199px;
      width: 398px;
      font-size: 40px;
      font-weight: 600;
      color: #ffffff;
      line-height: 1em;
      padding: 20px 0;
      background: linear-gradient(180deg, #f7e600 0%, #ff7d01 100%);
      box-shadow: 0px 4px 8px 0px #fe9101;
      border-radius: 40px;
    }
    .select,
    .goods {
      & > img,
      .good {
        position: absolute;
        width: 180px;
        height: 180px;
        &:nth-of-type(1) {
          left: 100px;
          top: 238px;
        }
        &:nth-of-type(2) {
          left: 274px;
          top: 238px;
        }
        &:nth-of-type(3) {
          left: 442px;
          top: 238px;
        }
        &:nth-of-type(4) {
          left: 442px;
          top: 408px;
        }
        &:nth-of-type(5) {
          left: 442px;
          top: 575px;
        }
        &:nth-of-type(6) {
          left: 274px;
          top: 575px;
        }
        &:nth-of-type(7) {
          left: 100px;
          top: 575px;
        }
        &:nth-of-type(8) {
          left: 100px;
          top: 408px;
        }
      }
      & > img {
        opacity: 0;
        transition: 0.3s;
        &.active {
          opacity: 1;
          &.biling {
            animation: bilingDraw 1s ease-in-out infinite;
          }
        }
      }
      .good {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 26px;
        .good-item {
          color: #fff;
          &.active {
            color: #e82035;
          }
        }
        .img {
          width: 80px;
          height: 80px;
          background-size: cover;
          background-position: center;
          margin: 0 auto;
          margin-bottom: 8px;
        }
      }
    }
  }
}
@keyframes bilingDraw {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
</style>